'use strict';

class RecurringEdit {
  constructor($routeParams, $location, recurringService) {
    this.$location = $location;
    this.recurringService = recurringService;
    this.number = $routeParams.number;
  }

  $onInit() {
    this.recurring = {};
    this.dueDate = null;

    this.load();
  }

  load() {
    this.recurringService.get(this.number)
      .then((resp) => {
        this.recurring = resp.data;
        this.dueDate = this.recurringService.calculateDueDate(resp.data.dueDate, resp.data.shipment.dates.next);
      });
  }

  formatShipment(string) {
    const i18n = {
      paper: 'Papir',
      email: 'E-post',
      ehf: 'EHF',
      agiro: 'Agiro',
      emailAndPaper: 'E-post og papir'
    };

    if (string in i18n) {
      return i18n[string];
    } else {
      return string;
    }
  }

  update() {
    this.recurringService.update(this.number, this.recurring)
      .then(() => this.load());
  }

  delete() {
    swal({
      title: 'Vil du virkelig slette denne utsendelsen?',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: true
    }, (answer) => {
      if (answer) {
        this.recurringService.delete(this.number)
          .then(() => this.$location.path('/fast-oppdrag'));
      }
    });
  }

  start() {
    swal({
      title: 'Vil du virkelig starte denne utsendelsen?',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: true
    }, (answer) => {
      if (answer) {
        this.recurringService.start(this.number)
          .then(() => this.load());
      }
    });
  }

  stop() {
    swal({
      title: 'Vil du virkelig stoppe denne utsendelsen?',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: true
    }, (answer) => {
      if (answer) {
        this.recurringService.stop(this.number)
          .then(() => this.load());
      }
    });
  }
}

RecurringEdit.$inject = ['$routeParams', '$location', 'recurringService'];

const recurringEdit = {
  controller: RecurringEdit,
  templateUrl: 'recurring/edit.html'
};

angular
  .module('SendRegning')
  .component('recurringEdit', recurringEdit)
  .config(($routeProvider) => {
    $routeProvider
      .when('/fast-oppdrag/:number', {
        title: 'Fast oppdrag',
        template: '<recurring-edit />',
        secure: true
      });
  });
